// extracted by mini-css-extract-plugin
export default {"gralLazyLoading":"LazyLoading_gralLazyLoading__zLSEQ","imgLazy":"LazyLoading_imgLazy__-53f0"};